export type UserEntityApi = {
  date_joined: string;
  last_name: string;
  is_staff: boolean;
  email: string;
  is_active: boolean;
  first_name: string;
  is_company_superuser: boolean;
};

export type UserEntity = {
  dateJoined: Date;
  lastName: string;
  isStaff: boolean;
  email: string;
  isActive: boolean;
  firstName: string;
  isCompanySuperuser: boolean;
};

/**
 * Статусы авторизации
 */
export enum AuthorizationState {
  // авторизован
  authorized = 'authorized',
  // авторизуется
  authorizing = 'authorizing',
  // не авторизован
  unauthorized = 'unauthorized',
}
